import Vue from "vue";
import Vuetify from "vuetify/lib";
import pt from "vuetify/src/locale/pt.ts";
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import FileCertificate from "@/assets/ic_file-certificate.vue";
import FileSigned from "@/assets/ic_file-signed.vue";
import Exchange from "@/assets/ic_exchange.vue";
import Permissions from "@/assets/ic_permissions.vue";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      fileCertificate: {
        component: FileCertificate
      },

      fileSigned: {
        component: FileSigned
      },
      
      permissions: {
        component: Permissions
      },

      exchange: {
        component: Exchange
      }
    }
  },
  lang: {
    locales: { pt },
    current: "pt"
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#2C3040",
        secondary: "#3A63DE",
        lightGreen: "#49DCBB",
        lightGray: "#D5D5E0",
        yellow: "#FFC55F",
        lightYellow: "#FFEDB9",
        darkGray: "#273142",
        whiteSmoke: "#FAFAFC",
        gray: "#A5A5A5",
        pink: "#EF5350",
        lightBlue: "#B5B5C3",
        success: "#49DCBB",
        error: "#EF5350",
        darkBluishGray: "#676778",
        lightestGray: "#9E9EA9",
        darkBlue: "#232633",
        ligthGray: "#EBEEF2",
        ghostWhite: "#F0F0F7",
        blue: "#3A63DE",
        lightestGreen: "#AAD8B6",
        lightestBlue: "#8DD8F8",
        lightCyan: "#A5ADB7",
        white: "#FFFFFF" 
      }
    }
  }
});
